/* funnls - Bare Wipes LP: scroll reveals + gentle parallax. Idempotent. */
(function () {
  if (window.__flpInit) return;
  window.__flpInit = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    // Scroll-in reveals. MUST include .flp-clip: those headings start fully
    // clipped and are invisible until they receive .is-in.
    var targets = document.querySelectorAll('.flp-reveal, .flp-clip');
    if (reduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add('is-in');
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.14, rootMargin: '0px 0px -8% 0px' }
      );
      targets.forEach(function (el) { io.observe(el); });
    }

    // Gentle parallax drift on marked elements
    var px = Array.prototype.slice.call(document.querySelectorAll('[data-flp-parallax]'));
    if (!reduced && px.length) {
      var ticking = false;
      var update = function () {
        ticking = false;
        var vh = window.innerHeight;
        px.forEach(function (el) {
          var r = el.getBoundingClientRect();
          var progress = (r.top + r.height / 2 - vh / 2) / vh; // -1..1 around center
          var amount = parseFloat(el.getAttribute('data-flp-parallax')) || 40;
          el.style.transform = 'translateY(' + (progress * -amount).toFixed(1) + 'px)';
        });
      };
      var onScroll = function () {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Backstop: whatever happens above, nothing stays hidden. If an element is
  // still un-revealed shortly after load, show it. Cheap, and it means a
  // future change to the observer can never blank a heading again.
  window.addEventListener('load', function () {
    setTimeout(function () {
      document.querySelectorAll('.flp-reveal:not(.is-in), .flp-clip:not(.is-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 1.2) el.classList.add('is-in');
      });
    }, 900);
  });
})();
